<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <TableNotas/>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import TableNotas from '@/router/views/nota_fiscal/components/table-notas'
import PageHeader from "@/components/page-header";

export default {
  page: {
    title: "Lista de Notas Fiscais",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    TableNotas
  },
  data() {
    return {
      title: "Lista de Nota Fiscal Eletrônica de Serviço (NFS-e)",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'NFS-e',
          active: true,
        },
      ],
    };
  },
  computed: {
    empresa: {
      get: function () {
        return this.$store.state.auth.currenEmpresa;
      },
    },
  },
  created() {
    let tipoEmpresa = parseInt(this.empresa.pes_tipopessoa);
    if (tipoEmpresa === 4) {
      this.$toast.error("Esta empresa não tem permissão para a utilização deste recurso")
      this.$router.push({name: 'painel'})
    }
  },
};
</script>


